import {
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';
import Failure from '../../../core/Failure';
import { IConstraint } from '@leedpulse-monorepo/interfaces';
import { TOrderByDirection } from '@leedpulse-monorepo/types';

/**
 * Note : If you want to orderBy, you can use the "orderBy" opérator and "asc" or "desc" value
 * 
 * @param constraints - The constraints to apply to the query.
 * @returns 
 */
async function getUsersByConstraints(constraints: IConstraint[] = []) {
  try {
    const usersRef = collection(firestore, FirestoreCollections.users);

    const queryConstraints = constraints.map((constraint) => {
      if(constraint.op === 'orderBy') {
        return orderBy(constraint.field, constraint.value as TOrderByDirection);
      }
      return where(constraint.field, constraint.op, constraint.value);
    });

    const q = query(usersRef, ...queryConstraints);
    const querySnapshot = await getDocs(q);

    const users: UserDoc[] = [];
    querySnapshot.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    return users;
  } catch (error: any) {
    throw new GetUsersByConstraintsFailure(error.message.toLocaleString());
  }
}

export class GetUsersByConstraintsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsersByConstraints;
